module.exports = __webpack_public_path__ + "img/0109f3c.jpg";